import type { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { formatPoints } from "@/lib/scoring";

/**
 * "8 / 10", the points a run earned under the rubric.
 *
 * The number that ranks, so it is the bold one; the denominator is there because a
 * rubric can be any size and "8" alone means nothing across challenges.
 */
export function ScoreCell({
  points,
  max,
  className,
  children,
}: {
  points: number | null;
  max: number;
  className?: string;
  children?: ReactNode;
}) {
  if (points === null) return <span className={cn("text-muted-foreground", className)}>—</span>;
  return (
    <span className={cn("inline-flex items-baseline gap-0.5 tabular-nums", className)}>
      <span className="font-semibold">{formatPoints(points)}</span>
      <span className="text-muted-foreground text-xs">/{formatPoints(max)}</span>
      {children}
    </span>
  );
}
